import { Component, Input } from '@angular/core';

import { BukTicketContentsType } from '../../models/buk-ticket.model';

@Component({
  selector: 'app-buk-ticket-contents-view',
  templateUrl: './buk-ticket-contents-view.component.html',
  styleUrls: ['./buk-ticket-contents-view.component.scss'],
})
export class BukTicketContentsViewComponent {
  @Input() type: BukTicketContentsType;
  @Input() image: string;
  @Input() title: string;
  @Input() author: string;
  @Input() placeholder: string;
}
